"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (options) {
    if (options === void 0) { options = {}; }
    var iframe = document.createElement("iframe");
    iframe.src = "https://biz.alibaba.com/contract/resource.htm?type=preload&referer=" + options.referer || document.location.href;
    iframe.style.display = "none";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "none";
    document.body.appendChild(iframe);
});
